import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="bg-background-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="relative overflow-hidden rounded-lg border border-background-200">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20background%20of%20connected%20timeline%20nodes%20and%20document%20shapes%20in%20deep%20vermilion%20and%20warm%20cream%20tones%2C%20geometric%20flat%20style%2C%20soft%20texture%2C%20wide%20composition%2C%20high%20detail&width=1600&height=600&seq=bl-cta-band-01&orientation=landscape"
              alt="17爆料网线索征集"
              title="17爆料网 - 线索征集"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-foreground-950/80"></div>
          </div>
          <div className="relative flex flex-col items-start gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12 md:py-16">
            <div className="max-w-2xl">
              <h2 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                手里有公开线索？一起把材料补齐
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                欢迎提供公开可见的事件线索、时间节点或来源链接。我们不采纳涉及个人隐私或无法核实来源的内容，所有投稿都会经过人工复核。
              </p>
            </div>
            <Link
              to="/contact"
              className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400 cursor-pointer"
            >
              <i className="ri-send-plane-line text-base"></i>
              提供线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}